<template>
  <div class="error">
    <img :src="robotSource" />
    <h3>{{ title }}</h3>
    <p>{{ message }}</p>

    <b-link :href="linkUrl" target="_blank">
      {{ linkText }} <icon kind="popout"></icon>
    </b-link>
  </div>
</template>

<script>
import Icon from '@/components/togo/icon';

const robotSource = require('@/assets/results-not-found-bot.svg');

const ErrorUi = {
  name: 'ErrorUi',

  components: {
    Icon
  },

  data() {
    return {
      robotSource
    };
  },

  props: {
    error: null
  },

  computed: {
    title() {
      return this.error && this.error.title && this.$t(this.error.title);
    },

    message() {
      return (this.error && this.error.message && this.$t(this.error.message));
    },

    linkText() {
      return this.error && this.error.linkText && this.$t(this.error.linkText);
    },

    linkUrl() {
      return this.error && this.error.linkUrl;
    }
  }
};

export default ErrorUi;
</script>

<style lang="sass">
  @import "src/scss/variables"
  @import "src/scss/mixins"

  .error
    img
      margin-bottom: 30px

      @include layout-vertical
        display: none
</style>
